/* eslint-disable react/no-array-index-key */

import { FieldArray, Form, Formik } from 'formik';
import React, { useState } from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import style from './OrariForm.module.scss';
import { setOrariData } from '../../../../app/slices/orariSlice';
import OrarioTile from '../OrarioTile/OrarioTile';
import PrimaryButton from '../../../../components/Buttons/PrimaryButton/PrimaryButton';
import SecondaryButton from '../../../../components/Buttons/SecondaryButton/SecondaryButton';
import store from '../../../../app/store/store';
import api from '../../../../core/api';

function OrariForm() {
  const [state, setState] = useState({});
  const [buttonText, setButtonText] = useState('Non voglio inserire altre informazioni');
  const initialValues = {
    giorni: [
      {
        weekDay: 1,
        giorno: 'LUN',
        isClosed: true,
        fullDay: false,
        orari: [{
          dal: '08:00', all: '20:00', dal2: '13:00', all2: '14:00',
        }],
      },
      {
        weekDay: 2,
        giorno: 'MAR',
        isClosed: false,
        fullDay: false,
        orari: [{
          dal: '08:00', all: '20:00', dal2: '13:00', all2: '14:00',
        }],
      },
      {
        weekDay: 3,
        giorno: 'MER',
        isClosed: false,
        fullDay: false,
        orari: [{
          dal: '08:00', all: '20:00', dal2: '13:00', all2: '14:00',
        }],
      },
      {
        weekDay: 4,
        giorno: 'GIO',
        isClosed: false,
        fullDay: false,
        orari: [{
          dal: '08:00', all: '20:00', dal2: '13:00', all2: '14:00',
        }],
      },
      {
        weekDay: 5,
        giorno: 'VEN',
        isClosed: false,
        fullDay: false,
        orari: [{
          dal: '08:00', all: '20:00', dal2: '13:00', all2: '14:00',
        }],
      },
      {
        weekDay: 6,
        giorno: 'SAB',
        isClosed: false,
        fullDay: false,
        orari: [{
          dal: '08:00', all: '20:00', dal2: '13:00', all2: '14:00',
        }],
      },
      {
        weekDay: 7,
        giorno: 'DOM',
        isClosed: true,
        fullDay: false,
        orari: [{
          dal: '08:00', all: '20:00', dal2: '13:00', all2: '14:00',
        }],
      },
    ],
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNextStep = (values) => {
    dispatch(setOrariData(values));
    navigate('/servizi');
  };

  const handleSendData = async (values) => {
    await dispatch(setOrariData(values));
    await setState({
      form: store.getState().form.form,
      giorni: store.getState().orari.giorni,
      servizi: store.getState().servizi.servizi,
      poltrone: store.getState().poltrone.poltrone,
    });
    api.post('/business/auth/autoSignUp', state).then((res) => (res.status === 200 ? navigate('/riepilogo') : setButtonText('Riprova')));
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values) => {
        handleNextStep(values);
      }}
    >
      {({ values, setFieldValue }) => (
        <Form className={clsx(style.form)}>
          <h2 className={clsx(style.page__title)}>Personalizza il tuo salone:</h2>
          <h3 className={clsx(style.page__subtitle)}>
            Inserisci gli orari settimanali di apertura e chiusura del tuo salone
          </h3>
          <FieldArray name="giorni">
            {() => (
              values.giorni.map((giorno, index) => (
                <OrarioTile
                  giorni={values.giorni}
                  giorno={giorno}
                  setFieldValue={setFieldValue}
                  index={index}
                  key={giorno.weekDay}
                />
              ))
            )}
          </FieldArray>
          <div className={clsx(style.form__footer)}>
            <PrimaryButton type="submit" label="Avanti" fullWidth />
            <SecondaryButton type="button" label={buttonText} onClick={() => handleSendData(values)} fullWidth />
          </div>

        </Form>
      )}
    </Formik>
  );
}

export default OrariForm;
